import React from 'react';

const LatestInformation: React.FC = () => (
  <div className="static-page">
    <h1>Latest Information</h1>
    <ul>
      <li>NIW Appeal Sustained by AAO After Denial by TSC Officer XM1698 (2025-05-22)</li>
      <li>NIW Approval Following the Appeal against TSC Officer XM2148 (2025-05-21)</li>
      <li>I-485 Filing Eligibility (2025-05-14)</li>
      <li>890 Approvals in February 2025 and 1,729 Approvals in 2025 for I-140 EB1A, EB1B, EB-2 NIW and O1 Petitions (2025-04-29)</li>
    </ul>
    <p>Stay up to date with the latest news and updates from our firm and the U.S. immigration system.</p>
  </div>
);

export default LatestInformation;
